import { OperationsDashboardSection } from "./sections/operations-dashboard.section";

export const AdminDashboard = () => <OperationsDashboardSection />;
